export enum AlertType {
    CONTRAINDICATION = 1,
    PRECAUTION_FOR_USE = 2,
    OVERDOSAGE = 3,
    ALLERGY = 6,
    STOPP = 7,
    REDUNDANCY = 4,
    INTERACTION = 0,
    POSOLOGY = 8,
    SAM = 9,
    IPC = 5,
}
